// extracted by mini-css-extract-plugin
export default {"grab":"cursors__grab__r48cy","grabbing":"cursors__grabbing__GTa5r","pointer":"cursors__pointer__fgloL"};